// @core/api/endpoints/notifications/render_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RenderTemplateRequest,
  RenderTemplateResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Render template preview
 * Renders a notification template with provided variables and returns the result. Useful for previewing how a notification will look before sending.
 */
export async function RenderTemplate(
  template_id: string,
  data: RenderTemplateRequest,
  options?: RequestOptions
): Promise<RenderTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/templates/:template_id/render`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<RenderTemplateResponse>(requestPath, data, requestOptions);
}
